import { jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { RuntimeProvider } from "../runtimes/react";
import { Page as PageMeta } from "../components/page";
import { MakeswiftClient } from "../api/react";
const Page = memo(({ snapshot, runtime }) => {
  const client = useMemo(
    () => new MakeswiftClient({
      uri: new URL("graphql", snapshot.apiOrigin).href,
      cacheData: snapshot.cacheData,
      localizedResourcesMap: snapshot.localizedResourcesMap,
      locale: snapshot.locale ? new Intl.Locale(snapshot.locale) : void 0
    }),
    [snapshot]
  );
  const rootElements = /* @__PURE__ */ new Map([[snapshot.document.id, snapshot.document.data]]);
  snapshot.document.localizedPages.forEach((localizedPage) => {
    rootElements.set(localizedPage.elementTreeId, localizedPage.data);
  });
  return /* @__PURE__ */ jsx(
    RuntimeProvider,
    {
      client,
      rootElements,
      preview: snapshot.preview,
      runtime,
      children: /* @__PURE__ */ jsx(PageMeta, { document: snapshot.document }, snapshot.document.data.key)
    }
  );
});
import { Makeswift } from "./client";
import { PreviewModeScript } from "./preview-mode";
import { Document } from "./document";
import { forwardNextDynamicRef } from "./dynamic";
export {
  Document,
  Makeswift,
  Page,
  PreviewModeScript,
  forwardNextDynamicRef
};
//# sourceMappingURL=index.js.map